/**
 * LocationsModal - Modal de ubicaciones de productos
 *
 * Modal que muestra las ubicaciones disponibles para un producto
 * específico en el almacén. Incluye:
 * - Lista de ubicaciones con información detallada
 * - Información del producto seleccionado
 * - Integración con la API de ubicaciones
 * - Diseño responsive para diferentes tamaños de pantalla
 */

import React, { forwardRef } from 'react';
import {
  LocationsModal as SharedLocationsModal,
  type LocationsModalProps,
} from '@modules/OrderPreparation/shared';

export const LocationsModal = forwardRef<any, LocationsModalProps>(
  (props, ref) => {
    return (
      <SharedLocationsModal
        {...props}
        ref={ref}
        namespace="packingModule"
        dataTestId="packing-locations-modal"
      />
    );
  }
);

LocationsModal.displayName = 'LocationsModal';
